// import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
// import cn from 'classnames';
import { getNotificationsUnreadCount } from '@api/apiClient/notifications';
import { useProfile } from '@contexts/ProfileContext';
import Page from '@components/Page';
import NotificationsTab from './tabs/NotificationsTab.tsx';
import useTab from '@hooks/useTab';
import { TabsList, TabsContent } from '@components/Tabs/Tabs';
import FireIcon from '@assets/icons/fire-red.svg';
import PricesIcon from '@assets/icons/prices.svg';
import NewsIcon from '@assets/icons/news.svg';
import styles from './NotificationsPage.module.css';

const NotificationsPage: React.FC = (): React.ReactElement => {

  const { account } = useProfile();
  const currentLanguage = account!.region;
  const { t } = useTranslation();

  const {
    data: notificationsData,
    refetch: refetchGetNotificationsUnreadCount
  } = useQuery({
    queryKey: ['getNotificationsUnreadCount', currentLanguage],
    queryFn: () => getNotificationsUnreadCount(currentLanguage),
    retry: 1
  });

  const tabs = [
    {
      id: 'all',
      title: t('notificationsPage.allTabTitle'),
      content: (
        <NotificationsTab
            category="Unknown"
            refetchGetNotificationsUnreadCount={refetchGetNotificationsUnreadCount}
        />
      ),
      count: notificationsData?.all ?? 0,
    },
    {
      id: 'important',
      title: (<>
        <img src={FireIcon} alt="Icon" className={styles.tabIcon} />
        {t('notificationsPage.importantTabTitle')}
      </>),
      content: (
        <NotificationsTab
            category="Important"
            refetchGetNotificationsUnreadCount={refetchGetNotificationsUnreadCount}
        />
      ),
      count: notificationsData?.important ?? 0,
    },
    {
      id: 'offersAndPricing',
      title: (<>
        <img src={PricesIcon} alt="Icon" className={styles.tabIcon} />
        {t('notificationsPage.pricesTabTitle')}
      </>),
      content: (
        <NotificationsTab
            category="OffersAndPricing"
            refetchGetNotificationsUnreadCount={refetchGetNotificationsUnreadCount}
        />
      ),
      count: notificationsData?.offersAndPricing ?? 0,
    },
    {
      id: 'news',
      title: (<>
        <img src={NewsIcon} alt="Icon" className={styles.tabIcon} />
        {t('notificationsPage.newsTabTitle')}
      </>),
      content: (
        <NotificationsTab
            category="News"
            refetchGetNotificationsUnreadCount={refetchGetNotificationsUnreadCount}
        />
      ),
      count: notificationsData?.news ?? 0,
    },
  ];

  const { activeTab, setActiveTab } = useTab(tabs);

  return (
    <Page title={t('notificationsPage.title')}>
      <div className={styles.tabsRow}>
        <TabsList
          onChange={setActiveTab}
          tabs={tabs}
          value={activeTab}
        />
      </div>
      <TabsContent
        tab={tabs.find((tab) => (tab.id === activeTab))}
      />
    </Page>
  );
};

export default NotificationsPage;
